
const config = {
  baseUrl: `${process.env.VUE_APP_BASE_URL}`, // 项目地址
  baseApi: `${process.env.VUE_APP_BASE_API}`, // 本地api请求地址
  staticImg: `${process.env.VUE_APP_BASE_OSS}`,
  roleRouter: {
    outerPath: '', 
    innerPath: ''
  },
  reqAuth: 'Basic Ympkcy11c2VyOnVzZXItc2VjcmV0NDMyMQ==', // 请求cookie
  whiteList: ['/login', '/404', 'error','/user/treaty','/download','/','/home']

}

export default config
